export function imgChange(id: string) {
  window.dispatchEvent(new CustomEvent('imgChange', { detail: id }));
}

export function onImgChange(callback: (id: string) => void) {
  //@ts-ignore - this is fine 🐕🔥
  window.addEventListener('imgChange', (e: CustomEvent) => callback(e.detail));
}
